import { render, staticRenderFns } from "./WeightGuideNew.vue?vue&type=template&id=53d5274e"
import script from "./WeightGuideNew.vue?vue&type=script&lang=js"
export * from "./WeightGuideNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports